export default __webpack_public_path__ + "static/media/about-5.51f4719c.jpg";